module.exports = __webpack_public_path__ + "static/media/storeID.0974eab1.svg";